import getRuntimeConfig from "./RuntimeConfig";
import type { AuthMode } from "./AuthService";

const config = {
  "ApiUrl": getRuntimeConfig().API_BASE || "https://api." + getRuntimeConfig().DNS_BASE,
  "MqttUri": getRuntimeConfig().MQTT_URI || "wss://broker." + getRuntimeConfig().DNS_BASE + "/ws",
  "InfluxUrl": getRuntimeConfig().INFLUX_URL || "https://influx." + getRuntimeConfig().DNS_BASE,
  "InfluxToken": "b_KKMOXYUlxjK9T4oZ_fwjSKHDC3cmzpi5sCxfCnb6Ovj6NKiZnz0dFK-dKufvxFpNcTnJmcyOLinH2aLIqFIw==",
  "AdminerUrl": getRuntimeConfig().ADMINER_URL || "https://adminer." + getRuntimeConfig().DNS_BASE,
  "GrafanaUrl": getRuntimeConfig().GRAFANA_URL || "https://grafana." + getRuntimeConfig().DNS_BASE,
  "RedisUrl": getRuntimeConfig().REDIS_URL || "https://redis." + getRuntimeConfig().DNS_BASE,
  "DocumentationUrl": getRuntimeConfig().DOCUMENTATION_URL || "https://doc." + getRuntimeConfig().DNS_BASE,
  "AuthProxyUrl": getRuntimeConfig().AUTH_PROXY_URL || "",
  "OAuthProviderUrl": getRuntimeConfig().OAUTH_PROVIDER_URL || "",
  "OidcClientId": getRuntimeConfig().OIDC_CLIENT_ID || "",
  "OidcScopes": getRuntimeConfig().OIDC_SCOPES || "",
}

// Helper function to get the correct API URL based on authentication mode
export const getApiUrl = (): string => {
  const authMode = sessionStorage.getItem("auth_mode") as AuthMode;
  if (authMode === "oidc") {
    return config.AuthProxyUrl;
  }
  return config.ApiUrl;
}

export default config;